import {
  AppBar,
  Button,
  ButtonGroup,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import { TableSortLabel, SvgIcon } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import AddIcon from "@mui/icons-material/Add";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import ReactQuill from "react-quill";
import { Link, useHistory, useLocation } from "react-router-dom";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import "../index.css";
import http from "../services/httpService";
import handleSubmitValidation from "../utils/handleSubmitValidation";
import handleValidation from "../utils/handleValidations";
import {
  getToday,
  manualAdviceTabsPath,
  cdt_create_advice,
} from "../utils/varialbles";
import { SettingsInputComponent } from "@material-ui/icons";
import { textAlign } from "@mui/system";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { InvestmentPlan } from "../pdfreact/InvestmentPlan";
import { CancelOutlined } from "@mui/icons-material";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { convertToHTML } from "draft-convert";
import Cdtcreateadvicetabs from "../misReport/cdtcreateadvicetabs";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    paddingTop: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  submitButton: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
  },
  gridDevider: {
    marginTop: theme.spacing(6),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  lableColor: {
    color: "#393939",
    paddingTop: "10px",
  },
  select: {
    height: 36,
    width: 235,
    marginLeft: 25,
  },
  mobileCode: {
    height: 36,
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },

  checked: {},
}));
var acceptCountryList = true;
var acceptAlertList = true;
const filter = createFilterOptions();

function CreateAdviseRequest() {
  let history = useHistory();
  const [value, setValue] = useState(null);

  const [categoryDropDowm, setcategoryDropDowm] = useState([]);
  const [updatedCountryList, setUpdatedCountryList] = useState([]);
  const [checkedCheckboxes, setCheckedCheckboxes] = useState([]);
  const [selectedAssestType, setSelectedassestType] = useState({});
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedAssest, setSelectedAsset] = useState("");
  const [selectedAmount, setSelectedAmount] = useState("");
  const [selectedIndia, setSelectedIndia] = useState([]);
  const [selectedUSA, setSelectedUSA] = useState([]);
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("asc");
  const [editAmount, setEditAmount] = useState("");
  const [editingAmount, setEditingAmount] = useState("");
  const [differnetCountries, setDifferentCountries] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [deletingCountry, setDeletingCountry] = useState({});
  const [selectedCanda, setSelectedCanada] = useState([]);
  const [distinctIndia, setDistinctIndia] = useState([]);
  const [distinctUSA, setDistinctUSA] = useState([]);
  const [distinctCanada, setDistinctCanada] = useState([]);
  const [investmentName, setInvestmentName] = useState("");
  const [isinNumbers, setIsinNumbers] = useState({});
  const [assestType, setAssestType] = useState("");
  const [isinNumber, setIsinNumber] = useState("");
  const [validAmount, setValidAmount] = useState(false);
  const [filteredAssestType, setFilteredAssetType] = useState([]);
  const [countriesList, setCountriesList] = useState([]);
  const [assestName, setAssestName] = useState([]);
  const location = useLocation();
  const [deleteCountry, setDeleteCountry] = useState(false);
  const [editProposal, setEditProposal] = useState(false);
  const [validCount, setValidCount] = useState(1);
  const [validProposal, setValidProposal] = useState(false);

  const [editCountryAmount, setEditCountryAmount] = useState(true);
  const [countryValidations, setCountryValidations] = useState([]);
  const [country, setCountry] = useState([
    {
      id: 1,
      value: "India",
      label: "India",
    },
    {
      id: 2,
      value: "Canada",
      label: "Canada",
    },
    {
      id: 3,
      value: "USA",
      label: "USA",
    },
  ]);
  const myparam = location.state;
  const [indiaColumns, setIndiaColumns] = useState([
    {
      headerName: "ISINCode",
      id: "ISINCode",
      show: true,
      minWidth: 200,
    },
    {
      headerName: "Amount",
      id: "amount",
      show: true,
      minWidth: 200,
    },
    {
      headerName: "Asset Type",
      id: "assettype",
      show: true,
      minWidth: 200,
    },
    {
      headerName: "Country",
      id: "country",
      show: true,
      minWidth: 200,
    },
    {
      headerName: "Stock Name",
      id: "stockname",
      show: true,
      minWidth: 200,
    },
    { id: "detailsButton", headerName: "", minWidth: 150 },
    { id: "editButton", headerName: "", minWidth: 150 },
  ]);
  const [uSAColumns, setUSAColumns] = useState([
    {
      headerName: "ISINCode",
      id: "ISINCode",
      show: true,
      minWidth: 200,
    },
    {
      headerName: "Amount",
      id: "amount",
      show: true,
      minWidth: 200,
    },
    {
      headerName: "Asset Type",
      id: "assettype",
      show: true,
      minWidth: 200,
    },
    {
      headerName: "Country",
      id: "country",
      show: true,
      minWidth: 200,
    },
    {
      headerName: "Stock Name",
      id: "stockname",
      show: true,
      minWidth: 200,
    },
    { id: "detailsButton", headerName: "", minWidth: 150 },
    { id: "editButton", headerName: "", minWidth: 150 },
  ]);
  const [candaColumns, setCandaColumns] = useState([
    {
      headerName: "ISINCode",
      id: "ISINCode",
      show: true,
      minWidth: 200,
    },
    {
      headerName: "Amount",
      id: "amount",
      show: true,
      minWidth: 200,
    },
    {
      headerName: "Asset Type",
      id: "assettype",
      show: true,
      minWidth: 200,
    },
    {
      headerName: "Country",
      id: "country",
      show: true,
      minWidth: 200,
    },
    {
      headerName: "Stock Name",
      id: "stockname",
      show: true,
      minWidth: 200,
    },
    { id: "detailsButton", headerName: "", minWidth: 150 },
    { id: "editButton", headerName: "", minWidth: 150 },
  ]);

  const [editorAbovetable, seteditorAbovetable] = useState(() =>
    EditorState.createEmpty()
  );

  const [editorBelowtable, seteditorBelowtable] = useState(() =>
    EditorState.createEmpty()
  );

  const [convertedContentAboveTable, setconvertedContentAboveTable] =
    useState(null);
  const [convertedContentBelowTable, setConvertedContentBelowTable] =
    useState(null);

  const _contentState = ContentState.createFromText("Enter Text Here");
  const raw = convertToRaw(_contentState); // RawDraftContentState JSON
  const [contentState, setContentState] = useState(raw);

  useEffect(() => {
    let html = convertToHTML(editorAbovetable.getCurrentContent());
    setconvertedContentAboveTable(html);
  }, [editorAbovetable]);

  useEffect(() => {
    let html = convertToHTML(editorBelowtable.getCurrentContent());
    setConvertedContentBelowTable(html);
  }, [editorBelowtable]);

  const formattedDate = getToday();
  const [pdfName, setpdfName] = useState(myparam.name);
  const [showPDFeditfields, setshowPDFeditfields] = useState(false);
  const PDFeditfields = () => {
    setshowPDFeditfields(true);
  };
  const [pdfcontent, setpdfcontent] = useState({
    date: formattedDate,
  });

  //Name to show at Pdf and filename
  // Capitalize all intials of the name
  let customerName = pdfName
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  const handlePdfContent = (e, para) => {
    setpdfcontent((prevState) => ({
      ...prevState,
      [para]: e.target.value,
    }));
  };

  const classes = useStyles();

  const handleClose = () => {
    setDeleteCountry(false);
    setEditModal(false);
    setEditProposal(false);
  };
  const submitDelete = () => {
    http
      .delete("updatemanualrequest/" + deletingCountry + "/")
      .then((res) => {
        toast.success("Deleted SuccessFully");
        setDeleteCountry(false);
        getAdviceList();
        setDeletingCountry("");
        // handleCheckBoxChange()
      })
      .catch((error) => {});
  };
  const editCountry = () => {
    http
      .patch("updatemanualrequest/" + editingAmount + "/", {
        amount: editAmount,
      })
      .then((res) => {
        toast.success("Updated SuccessFully");
        setEditModal(false);
        getAdviceList();
        setDeletingCountry("");
        setEditAmount("");
        // handleCheckBoxChange()
      })
      .catch((error) => {});
  };

  useEffect(() => {
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter");
    localStorage.removeItem("selectedfiltersdata");
    localStorage.removeItem("selectedinvestorfiltersdata");

    getVantageList();
    getAdviceList();
    let uniqueCountry = myparam.country_amount.country_name;

    if (Array.isArray(myparam.country_amount) === true) {
      let updatedCountries = country.filter((itemA) => {
        return myparam.country_amount.find((itemB) => {
          return itemA.value === itemB.country_name;
        });
      });
      setCountry(updatedCountries);
      // setCheckedCheckboxes(updatedCountries);
    } else {
      const uniqueCountries = country.filter((ele) => {
        return ele.value === uniqueCountry;
      });
      setCountry(uniqueCountries);
    }
  }, [validCount]);
  const getAdviceList = () => {
    http
      .get("advicerequestsbyid/" + myparam.reqid + "/")
      .then((response) => {
        const filteredIndia = response.data.Data.filter((employee) => {
          return employee.country === "India";
        });
        setSelectedIndia(filteredIndia);
        // setDistinctIndia(filteredIndia)
        const filteredUSA = response.data.Data.filter((employee) => {
          return employee.country === "USA";
        });
        setSelectedUSA(filteredUSA);
        // setDistinctUSA(filteredUSA)
        const filteredCanda = response.data.Data.filter((employee) => {
          return employee.country === "Canada";
        });
        setSelectedCanada(filteredCanda);
        // setDistinctCanada(filteredCanda)
      })
      .catch((error) => {});
    http
      .get("validationrequest/" + myparam.reqid + "/")
      .then((res) => {
        setCountryValidations(res.data.Data);
      })
      .catch((err) => {});
  };
  const DeleteRole = (object) => {
    setDeleteCountry(true);
    setDeletingCountry(object.id);
  };
  const EditCountry = (object) => {
    setEditCountryAmount(true);
    setEditingAmount(object.id);
    setIsinNumbers(object);
    setEditModal(true);
    setEditAmount(object.amount);
  };
  const selectedCountriesList = () => {
    let uniqueCountry = myparam.country_amount.country_name;
    if (Array.isArray(myparam.country_amount) === true) {
      let distinctCountries = differnetCountries.filter((itemA) => {
        return myparam.country_amount.find((itemB) => {
          return itemA.Country === itemB.country_name;
        });
      });
      setCountriesList(distinctCountries);
    } else {
      const uniqueCountries = differnetCountries.filter((ele) => {
        return ele.Country === uniqueCountry;
      });
      setCountriesList(uniqueCountries);
    }
  };
  const handleCheckBoxChange = (e, s, id) => {
    const checkedBoxes = [...checkedCheckboxes];
    if (e.target.checked) {
      checkedBoxes.push(s);
    } else {
      const index = checkedBoxes.findIndex((ch) => ch.id === s.id);
      checkedBoxes.splice(index, 1);
    }
    setCheckedCheckboxes(checkedBoxes);
    // let distinctIndias = selectedIndia.filter((itemA) => {
    //     return checkedBoxes.find((itemB) => {
    //         return itemA.country === itemB.value
    //     })
    // });

    // setDistinctIndia(distinctIndias);
    // let distinctUSA = selectedUSA.filter((itemA) => {
    //     return checkedBoxes.find((itemB) => {
    //         return itemA.country === itemB.value
    //     })
    // });

    // setDistinctUSA(distinctUSA);

    // let distinctCanada = selectedCanda.filter((itemA) => {
    //     return checkedBoxes.find((itemB) => {
    //         return itemA.country === itemB.value
    //     })
    // });

    // setDistinctCanada(distinctCanada);
  };

  const gotoAdviceRequest = (event) => {
    if (location.string === "cdtAdvices") {
      history.push({
        pathname: cdt_create_advice,
      });
    } else {
      history.push({
        pathname: manualAdviceTabsPath,
      });
    }
  };

  const [comments, setComments] = useState("");

  const sendToProposal = () => {
    if (acceptCountryList === false) {
      http
        .get("invreq_by_id/" + myparam.reqid + "?comment=" + comments)
        .then((res) => {
          toast.success("Advise sent successFully");
          setEditProposal(false);
          setTimeout(() => {
            gotoAdviceRequest();
          }, 2000);
        })
        .catch((err) => {});
    } else {
    }
    if (acceptAlertList === false) {
      http
        .get("invreq_by_id/" + myparam.reqid + "/")
        .then((res) => {
          toast.success("Advise sent successFully");
          setEditProposal(false);
          setTimeout(() => {
            gotoAdviceRequest();
          }, 2000);
        })
        .catch((err) => {});
    } else {
    }
  };

  const getVantageList = (type) => {
    http
      .get("/assetname")
      .then((response) => {
        if (response && response.data && response.data.Data) {
          setUpdatedCountryList(response.data.Data);
          const uniqueIds = [];
          const unique = response.data.Data.filter((element) => {
            const isDuplicate = uniqueIds.includes(element.Country);

            if (!isDuplicate) {
              uniqueIds.push(element.Country);

              return true;
            }

            return false;
          });
          // setCountriesList(unique);
          // setCountriesList(unique);
          setDifferentCountries(unique);

          let uniqueCountry = myparam.country_amount.country_name;
          if (Array.isArray(myparam.country_amount) === true) {
            let distinctCountries = unique.filter((itemA) => {
              return myparam.country_amount.find((itemB) => {
                return itemA.Country === itemB.country_name;
              });
            });
            setCountriesList(distinctCountries);
          } else {
            const uniqueCountries = unique.filter((ele) => {
              return ele.Country === uniqueCountry;
            });
            setCountriesList(uniqueCountries);
          }
        }
      })
      .catch((error) => {
        toast.error("Error found");
      });
  };
  const handleCountryChange = (event) => {
    let countryName = event.target.value;
    setSelectedCountry(event.target.value);
    const filtered = updatedCountryList.filter((employee) => {
      return employee.Country === countryName;
    });
    setAssestName(filtered);
    setValidAmount(false);
  };
  const getAssestDetails = (event) => {
    let assetValue = event.target.value.toLocaleLowerCase();

    var filteredItems = assestName.filter(
      (item) => item.Investment_Name.toLocaleLowerCase().includes(assetValue)
      // item.title.toLocaleLowerCase().includes(assetValue)
    );
    if (filteredItems.length !== 0) {
      setFilteredAssetType(filteredItems);
    } else {
      setFilteredAssetType([]);
    }
    setFilteredAssetType(filteredItems);
  };

  const getAssestName = (event, v) => {
    if (v !== null) {
      setSelectedassestType(v);
      setAssestType(v.Asset_Class);
      setIsinNumber(v.ISINCode);
      setInvestmentName(v.Investment_Name);
    } else {
      setSelectedassestType({});
      setAssestType("");
      setIsinNumber("");
      setInvestmentName("");
    }
  };
  const defaultProps = {
    options: assestName,
    getOptionLabel: (option) => option.Investment_Name,
  };

  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    // let tempRows = [...rows];
    // let finalRows = handleSort(property, format, tempRows, isAsc);
    // setRows(finalRows);
    // setPage(0);
  };
  const handleSubmitAdviceList = () => {
    if (
      !assestType ||
      !isinNumber ||
      !selectedCountry ||
      !myparam.reqid ||
      !selectedAmount ||
      !value
    ) {
      toast.error("Please Fill all the fields");
    } else {
      const formData = {
        assettype: assestType,
        ISINCode: isinNumber,
        country: selectedCountry,
        request: myparam.reqid,
        amount: selectedAmount,
        stockname: value,
      };
      clearFileds();
      http
        .post("manualadvice", formData)
        .then((response) => {
          if (response.status === 201) {
            // handleCheckBoxChange();
            setAssestType("");
            setIsinNumber("");
            setInvestmentName("");
            setValue(null);
            setSelectedAmount("");
            getAdviceList();
            setTimeout(() => {
              selectedCountriesList();
            }, 3000);
            assestName.splice(0, assestName.length);
            let emptyCountries = [];
            setCountriesList(emptyCountries);
            setSelectedCountry("");
            // countriesList.splice(0, countriesList.length)
            toast.success("Added successfully");
          }
        })
        .catch((error) => {});
    }
  };

  const amountValidations = (event) => {
    let currentAmount = event.target.value;
    setSelectedAmount(currentAmount);

    if (Array.isArray(myparam.country_amount) === true) {
      myparam.country_amount.forEach((itemA) => {
        if (itemA.country_name === selectedCountry) {
          if (parseInt(itemA.rupees) >= currentAmount) {
            setValidAmount(true);
          } else {
            setValidAmount(false);
          }
        }
      });
    } else {
      const validCountry = myparam.country_amount.country_name;
      if (validCountry === selectedCountry) {
        if (parseInt(myparam.country_amount.rupees) >= currentAmount) {
          setValidAmount(true);
        } else {
          setValidAmount(false);
        }
      }
    }
  };

  const editAmountValidations = (event) => {
    let currentAmount = event.target.value;
    setEditAmount(currentAmount);

    if (Array.isArray(myparam.country_amount) === true) {
      myparam.country_amount.forEach((itemA) => {
        if (itemA.country_name === isinNumbers.country) {
          if (parseInt(itemA.rupees) >= currentAmount) {
            setEditCountryAmount(true);
          } else {
            setEditCountryAmount(false);
          }
        }
      });
    } else {
      const validCountry = myparam.country_amount.country_name;

      if (validCountry === isinNumbers.country) {
        if (parseInt(myparam.country_amount.rupees) >= currentAmount) {
          setEditCountryAmount(true);
        } else {
          setEditCountryAmount(false);
        }
      }
    }
  };

  const [dialouge, setOpenDialouge] = useState(false);
  const [openComment, setOpenComment] = useState(true);
  const openCommentClose = () => {
    setOpenComment(false);
  };

  const updateProposal = () => {
    setValidCount(0);
    var proposalValue = false;
    acceptAlertList = false;
    if (Array.isArray(myparam.country_amount) === true) {
      myparam.country_amount.forEach((itemA) => {
        countryValidations.forEach((itemB) => {
          if (itemA.country_name === itemB.country) {
            if (parseInt(itemA.rupees) === itemB.amount.amount__sum) {
              // toast.success(`${itemB.country}` + " " + 'added amount is matched with the country amount');
              acceptCountryList = false;
              acceptAlertList = false;
              acceptCountryList = true;
            } else {
              setEditProposal(false);
              acceptCountryList = true;
              acceptAlertList = true;
              toast.error(
                `${itemB.country}` +
                  " " +
                  "not matched with the country advised amount"
              );
            }
          }
        });
      });
    } else {
      countryValidations.forEach((itemA) => {
        if (itemA.country === myparam.country_amount.country_name) {
          if (
            itemA.amount.amount__sum === parseInt(myparam.country_amount.rupees)
          ) {
            toast.success(
              `${itemA.country}` +
                " " +
                "added amount is matched with the country amount"
            );
            proposalValue = true;
            // acceptCountryList = true;
            acceptAlertList = true;
            acceptCountryList = false;
            if (location.string === "cdtAdvices") {
              setOpenDialouge(true);
            }
          } else {
            toast.error(
              `${itemA.country}` +
                " " +
                "not matched with the country  advised amount"
            );
            setValidProposal(false);
            acceptCountryList = true;
            proposalValue = false;
            acceptAlertList = true;
          }
        }
      });
    }
    if (acceptAlertList === false) {
      toast.success("added amount is matched with the country amount");
      setEditProposal(true);
    }
    if (acceptCountryList === false) {
      // toast.success("added amount is matched with the country amount");
      setEditProposal(true);
    }

    // if (proposalValue) {
    //     setEditProposal(true);
    // }
  };

  const submitDialog = () => {
    if (!comments) {
      toast("Please enter the comments");
    } else {
      setOpenDialouge(false);
    }
  };

  const clearFileds = () => {
    setCountriesList([]);
  };
  const clearAuto = () => {
    setValue(null);
  };

  // Date for FileName

  // const currentDate = new Date();

  // const options = { day: "2-digit", month: "2-digit", year: "numeric" };
  // const formattedDate = currentDate
  //   .toLocaleDateString("en-GB", options)
  //   .replace(/\//g, "."); // /regex/g  g--> find all matches

  //   console.log(selectedIndia, "rows?");

  return (
    <Grid container component="main">
      <Grid container style={{ marginBottom: "30px" }}>
        <Button
          variant="outlined"
          color="default"
          startIcon={<ArrowBackIosIcon />}
          onClick={gotoAdviceRequest}
        >
          Back
        </Button>
        <h2 style={{ margin: "0px", marginLeft: "30px" }}>Create Advise</h2>
      </Grid>
      <Grid container>
        <Grid item xs={4} sm={4} md={2}>
          <Typography variant="p">Name</Typography>
          <Typography variant="h6">{myparam.name}</Typography>
        </Grid>
        <Grid item xs={4} sm={6} md={2}>
          <Typography variant="p">Mobile No:</Typography>
          <Typography variant="h6">{myparam.mobile}</Typography>
        </Grid>
        <Grid item xs={4} sm={6} md={2}>
          <Typography variant="p">Frequency</Typography>
          <Typography variant="h6">{myparam.freq}</Typography>
        </Grid>
        <Grid item xs={4} sm={6} md={2}>
          <Typography variant="p">Investment Amount</Typography>
          <Typography variant="h6">{myparam.amount}</Typography>
        </Grid>

        {/* <Grid item xs={4} sm={6} md={4}>
                    <Typography variant="p">View Country of Investment</Typography>
                    <div>
                        {
                            country.map((option, index) => {
                                return (
                                    <FormControlLabel
                                        key={option.id}
                                        control={<Checkbox
                                            onChange={(e) => handleCheckBoxChange(e, option, option.id)}
                                            checked={checkedCheckboxes[option.id]}
                                            name={option.value}
                                            classes={{ root: classes.radio, checked: classes.checked }}

                                        />}
                                        label={option.label}
                                        labelPlacement="end"

                                    />
                                )
                            })

                        }
                    </div>


                </Grid> */}
      </Grid>
      <Grid container style={{ paddingBottom: "20px" }}></Grid>
      <Grid container style={{ paddingBottom: "20px" }}>
        <Grid item xs={6} sm={10} md={2} lg={6}>
          <Grid container style={{ paddingBottom: "20px" }}>
            <Grid item xs={6} sm={6}>
              <Typography variant="h6">
                <InputLabel className={classes.lableColor}>
                  Choose Country
                  <span
                    style={{
                      color: "red",
                      fontSize: "1.2rem",
                      marginLeft: "0.2rem",
                    }}
                  >
                    *
                  </span>
                </InputLabel>
              </Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
              <Select
                displayEmpty
                labelId="statusLable"
                id="statusSelect"
                variant="outlined"
                className={classes.select}
                value={selectedCountry ? selectedCountry : ""}
                onChange={handleCountryChange}
                style={{
                  paddingBlock: 20,
                  width: "300px",
                }}
              >
                <MenuItem value="">Select</MenuItem>
                {countriesList.map((option) => {
                  return (
                    <MenuItem value={option.Country} key={option.id}>
                      {option.Country}
                    </MenuItem>
                  );
                })}
              </Select>
            </Grid>
          </Grid>

          <Grid container style={{ paddingBottom: "20px" }}>
            <Grid item xs={4} sm={6} md={2} lg={6}>
              <Typography variant="h6">
                <InputLabel className={classes.lableColor}>
                  Assest Name
                  <span
                    style={{
                      color: "red",
                      fontSize: "1.2rem",
                      marginLeft: "0.2rem",
                    }}
                  >
                    *
                  </span>
                </InputLabel>
              </Typography>
            </Grid>
            <Grid
              item
              xs={4}
              sm={6}
              md={4}
              lg={6}
              style={{
                paddingLeft: 24,
              }}
            >
              <Autocomplete
                value={value}
                style={{
                  width: "300px",
                }}
                onChange={(event, newValue) => {
                  // Create a new value from the user input
                  // if (newValue !== null) {
                  //     setSelectedassestType(newValue);
                  //     setAssestType(newValue.Asset_Class);
                  //     setIsinNumber(newValue.ISINCode);
                  //     setInvestmentName(newValue.Investment_Name);
                  //     setValue({
                  //         title: newValue.inputValue,
                  //     });
                  //     return
                  // }
                  // else {
                  //     setSelectedassestType({});
                  //     setAssestType("");
                  //     setIsinNumber("");
                  //     setInvestmentName('');
                  // }

                  if (newValue !== null) {
                    setValue(newValue.Investment_Name);
                    setAssestType(newValue.Asset_Class);
                    setIsinNumber(newValue.ISINCode);
                    return;
                  } else {
                    setAssestType("");
                    setIsinNumber("");
                  }
                  // setValue(newValue);
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  // Suggest the creation of a new value
                  if (params.inputValue !== "") {
                    filtered.push({
                      inputValue: params.inputValue,
                      title: `Add "${params.inputValue}"`,
                    });
                  }
                  return filtered;
                }}
                selectOnFocus
                // clearOnBlur
                id="free-solo-with-text-demo"
                options={assestName}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.Investment_Name;
                }}
                renderOption={(option) => option.Investment_Name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Assest Name"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid container style={{ paddingBottom: "20px" }}>
            <Grid item xs={4} sm={6} md={2} lg={6}>
              <Typography variant="h6">
                <InputLabel className={classes.lableColor}>
                  Assest Type
                  <span
                    style={{
                      color: "red",
                      fontSize: "1.2rem",
                    }}
                  >
                    *
                  </span>
                </InputLabel>
              </Typography>
            </Grid>

            <Grid item xs={4} sm={6} md={4}>
              <TextField
                variant="outlined"
                // value={selectedAssestType.Asset_Class}
                value={assestType}
                //   name={question.value}
                //   onChange={handleChange}
                //   disabled={question.disable}
                style={{
                  marginLeft: "25px",
                  width: "300px",
                }}
                disabled
              />
            </Grid>
          </Grid>

          <Grid container style={{ paddingBottom: "20px" }}>
            <Grid item xs={4} sm={6} md={2} lg={6}>
              <Typography variant="h6">
                <InputLabel className={classes.lableColor}>
                  ISIN Code
                  <span
                    style={{
                      color: "red",
                      fontSize: "1.2rem",
                      marginLeft: "0.2rem",
                    }}
                  >
                    *
                  </span>
                </InputLabel>
              </Typography>
            </Grid>
            <Grid item xs={4} sm={6} md={4}>
              <TextField
                variant="outlined"
                disabled
                value={isinNumber}
                style={{
                  marginLeft: "25px",
                  width: "300px",
                }}
              />
            </Grid>
          </Grid>
          <Grid container style={{ paddingBottom: "20px" }}>
            <Grid item xs={4} sm={6} md={2} lg={6}>
              <Typography variant="h6">
                <InputLabel className={classes.lableColor}>
                  Amount
                  <span
                    style={{
                      color: "red",
                      fontSize: "1.2rem",
                      marginLeft: "0.2rem",
                    }}
                  >
                    *
                  </span>
                </InputLabel>
              </Typography>
            </Grid>
            <Grid item xs={4} sm={6} md={4}>
              <TextField
                label="Enter"
                variant="outlined"
                type="number"
                value={selectedAmount}
                onChange={(e) => amountValidations(e)}
                // onChange={(e) => setSelectedAmount(e.target.value)}
                style={{
                  marginLeft: "25px",
                  width: "300px",
                }}
              />

              {selectedCountry ? (
                <>
                  {validAmount ? (
                    <p style={{ color: "blue" }}>Valid Amount</p>
                  ) : (
                    <p style={{ color: "red" }}>Please enter valid amount</p>
                  )}
                </>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={5} sm={5} md={4} style={{ marginLeft: "30px" }}>
          <p
            style={{
              textAlign: "right",
              paddingBottom: "10px",
              borderBottom: "1px solid #DFDFDF",
            }}
          >
            Advised Amount
          </p>

          <Grid
            container
            style={{ paddingBottom: "20px", marginBottom: "10px" }}
          >
            {Array.isArray(myparam.country_amount) ? (
              <>
                {myparam.country_amount.map((options) => {
                  return (
                    <>
                      <Grid
                        item
                        xs={6}
                        sm={6}
                        style={{
                          borderBottom: "1px solid #DFDFDF",
                          paddingBottom: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        {options.country_name}
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        sm={6}
                        style={{
                          borderBottom: "1px solid #DFDFDF",
                          paddingBottom: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        <p style={{ margin: "0px", textAlign: "right" }}>
                          {options.rupees}
                        </p>
                      </Grid>
                    </>
                  );
                })}
                <p
                  style={{
                    textAlign: "right",
                    width: "100%",
                    borderBottom: "1px solid #DFDFDF",
                    paddingBottom: "10px",
                  }}
                >
                  {myparam.amount}
                </p>
              </>
            ) : (
              <>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  style={{
                    marginBottom: "10px",
                    paddingBottom: "10px",
                    borderBottom: "1px solid #DFDFDF",
                  }}
                >
                  {myparam.country_amount.country_name}
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  style={{
                    marginBottom: "10px",
                    paddingBottom: "10px",
                    borderBottom: "1px solid #DFDFDF",
                  }}
                >
                  <p style={{ margin: "0px", textAlign: "right" }}>
                    {myparam.country_amount.rupees}
                  </p>
                </Grid>
                <p
                  style={{
                    textAlign: "right",
                    width: "100%",
                    borderBottom: "1px solid #DFDFDF",
                    paddingBottom: "10px",
                  }}
                >
                  {myparam.amount}
                </p>
              </>
            )}
            <Grid item xs={6} sm={6}></Grid>
          </Grid>
          <h3
            onClick={updateProposal}
            style={{ color: "#3f51b5", cursor: "pointer", display: "inline" }}
          >
            Send Proposal
          </h3>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <div style={{ float: "left" }}>
          <Button
            variant="contained"
            color="primary"
            style={{ marginLeft: 10, borderRadius: 60, textAlign: "right" }}
            startIcon={<AddCircleOutlineIcon />}
            className={"addBtn"}
            onClick={handleSubmitAdviceList}
          >
            Add to Advice List
          </Button>
        </div>
        <div style={{ float: "right" }}>
          <Button onClick={PDFeditfields} variant="contained" color="primary">
            Edit PDF
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ marginLeft: 10, borderRadius: 60, textAlign: "right" }}
            // startIcon={<AddCircleOutlineIcon />}
            // className={"addBtn"}
            // onClick={handleSubmitAdviceList}
          >
            <PDFDownloadLink
              document={
                <InvestmentPlan
                  tabledata={
                    selectedIndia.length > 0 ? selectedIndia : selectedUSA
                  }
                  custname={customerName}
                  pdfitems={pdfcontent}
                  pdftextabovetable={convertedContentAboveTable}
                  pdftextbelowtable={convertedContentBelowTable}
                />
              }
              fileName={
                "Investment Plan - " +
                customerName +
                " " +
                formattedDate +
                ".pdf"
              }
              style={{ color: "#fff", textDecoration: "none" }}
            >
              {({ blob, url, loading, error }) =>
                loading ? "Generate Plan" : "Generate Plan"
              }
            </PDFDownloadLink>
          </Button>
        </div>
      </Grid>
      <Grid container>
        <div
          style={{ overflow: "auto", display: "flex", whiteSpace: "nowrap" }}
          className="spacing"
        >
          <div style={{ display: "flex" }}>
            {selectedIndia.length !== 0 ? (
              <>
                <TableContainer
                  className={classes.container}
                  style={{ marginRight: "20px", width: "auto" }}
                >
                  <h2>India</h2>
                  <Table stickyHeader aria-label="sticky table" size="small">
                    <TableHead>
                      <TableRow>
                        {indiaColumns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                            className="prospect_table"
                          >
                            <TableSortLabel
                              active={orderBy === column.id}
                              direction={orderBy === column.id ? order : "asc"}
                              onClick={(e) =>
                                handleRequestSort(e, column.id, column.format)
                              }
                            >
                              {column.headerName}
                            </TableSortLabel>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedIndia.length !== 0 ? (
                        <>
                          {selectedIndia
                            // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={index + "a"}
                                  className="prospecttable"
                                >
                                  {indiaColumns.map((column, index) => {
                                    const value = row[column.id];
                                    return (
                                      <TableCell
                                        key={index + column.id}
                                        align={column.align}
                                        // onDoubleClick={() => viewProspectDetails(row)}
                                      >
                                        {column.format &&
                                        typeof value === "number" ? (
                                          column.format(value)
                                        ) : column.id === "type" &&
                                          value.length !== 0 ? (
                                          <>
                                            {Array.isArray(value)
                                              ? value.join(",")
                                              : "N/A"}
                                          </>
                                        ) : column.operation &&
                                          column.operation === "concate" ? (
                                          value +
                                          column.operand +
                                          row[column.with]
                                        ) : column.type &&
                                          column.type === "link" &&
                                          value ? (
                                          <Link
                                            variant="body2"
                                            // onClick={(e) => viewDetails(row)}
                                            // onClick={(e) => viewProspectDetails(row)}

                                            gutterBottom
                                            style={{ cursor: "pointer" }}
                                          >
                                            {value}
                                          </Link>
                                        ) : column.id === "detailsButton" ? (
                                          <div>
                                            <Button
                                              variant="contained"
                                              color="primary"
                                              style={{
                                                borderRadius: 10,
                                                marginLeft: 10,
                                                textTransform: "math-auto",
                                              }}
                                              onClick={() => EditCountry(row)}
                                            >
                                              Edit
                                            </Button>
                                          </div>
                                        ) : column.id === "editButton" ? (
                                          <div>
                                            <Button
                                              variant="contained"
                                              color="primary"
                                              style={{
                                                borderRadius: 10,
                                                marginLeft: 10,
                                                textTransform: "math-auto",
                                              }}
                                              onClick={() => DeleteRole(row)}
                                            >
                                              Delete
                                            </Button>
                                          </div>
                                        ) : (
                                          value
                                        )}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>
                              );
                            })}
                        </>
                      ) : (
                        <TableCell
                          colspan="6"
                          style={{ "text-align": "center", margin: "10px 0px" }}
                        >
                          Records Not Available
                        </TableCell>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            ) : (
              ""
            )}

            {selectedUSA.length !== 0 ? (
              <>
                <TableContainer
                  className={classes.container}
                  style={{ marginRight: "20px", width: "auto" }}
                >
                  <h2>USA</h2>
                  <Table stickyHeader aria-label="sticky table" size="small">
                    <TableHead>
                      <TableRow>
                        {uSAColumns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                            className="prospect_table"
                          >
                            <TableSortLabel
                              active={orderBy === column.id}
                              direction={orderBy === column.id ? order : "asc"}
                              onClick={(e) =>
                                handleRequestSort(e, column.id, column.format)
                              }
                            >
                              {column.headerName}
                            </TableSortLabel>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedUSA.length !== 0 ? (
                        <>
                          {selectedUSA
                            // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={index + "a"}
                                  className="prospecttable"
                                >
                                  {uSAColumns.map((column, index) => {
                                    const value = row[column.id];
                                    return (
                                      <TableCell
                                        key={index + column.id}
                                        align={column.align}
                                        // onDoubleClick={() => viewProspectDetails(row)}
                                      >
                                        {column.format &&
                                        typeof value === "number" ? (
                                          column.format(value)
                                        ) : column.id === "type" &&
                                          value.length !== 0 ? (
                                          <>
                                            {Array.isArray(value)
                                              ? value.join(",")
                                              : "N/A"}
                                          </>
                                        ) : column.operation &&
                                          column.operation === "concate" ? (
                                          value +
                                          column.operand +
                                          row[column.with]
                                        ) : column.type &&
                                          column.type === "link" &&
                                          value ? (
                                          <Link
                                            variant="body2"
                                            // onClick={(e) => viewDetails(row)}
                                            // onClick={(e) => viewProspectDetails(row)}

                                            gutterBottom
                                            style={{ cursor: "pointer" }}
                                          >
                                            {value}
                                          </Link>
                                        ) : column.id === "detailsButton" ? (
                                          <div>
                                            <Button
                                              variant="contained"
                                              color="primary"
                                              style={{
                                                borderRadius: 10,
                                                marginLeft: 10,
                                                textTransform: "math-auto",
                                              }}
                                              onClick={() => EditCountry(row)}
                                            >
                                              Edit
                                            </Button>
                                          </div>
                                        ) : column.id === "editButton" ? (
                                          <div>
                                            <Button
                                              variant="contained"
                                              color="primary"
                                              style={{
                                                borderRadius: 10,
                                                marginLeft: 10,
                                                textTransform: "math-auto",
                                              }}
                                              onClick={() => DeleteRole(row)}
                                            >
                                              Delete
                                            </Button>
                                          </div>
                                        ) : (
                                          value
                                        )}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>
                              );
                            })}
                        </>
                      ) : (
                        <TableCell
                          colspan="6"
                          style={{ "text-align": "center", margin: "10px 0px" }}
                        >
                          Records Not Available
                        </TableCell>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            ) : (
              ""
            )}
            {selectedCanda.length !== 0 ? (
              <>
                <TableContainer
                  className={classes.container}
                  style={{ marginRight: "20px", width: "auto" }}
                >
                  <h2>Canada</h2>
                  <Table stickyHeader aria-label="sticky table" size="small">
                    <TableHead>
                      <TableRow>
                        {candaColumns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                            className="prospect_table"
                          >
                            <TableSortLabel
                              active={orderBy === column.id}
                              direction={orderBy === column.id ? order : "asc"}
                              onClick={(e) =>
                                handleRequestSort(e, column.id, column.format)
                              }
                            >
                              {column.headerName}
                            </TableSortLabel>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedCanda.length !== 0 ? (
                        <>
                          {selectedCanda
                            // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={index + "a"}
                                  className="prospecttable"
                                >
                                  {candaColumns.map((column, index) => {
                                    const value = row[column.id];
                                    return (
                                      <TableCell
                                        key={index + column.id}
                                        align={column.align}
                                        // onDoubleClick={() => viewProspectDetails(row)}
                                      >
                                        {column.format &&
                                        typeof value === "number" ? (
                                          column.format(value)
                                        ) : column.id === "type" &&
                                          value.length !== 0 ? (
                                          <>
                                            {Array.isArray(value)
                                              ? value.join(",")
                                              : "N/A"}
                                          </>
                                        ) : column.operation &&
                                          column.operation === "concate" ? (
                                          value +
                                          column.operand +
                                          row[column.with]
                                        ) : column.type &&
                                          column.type === "link" &&
                                          value ? (
                                          <Link
                                            variant="body2"
                                            // onClick={(e) => viewDetails(row)}
                                            // onClick={(e) => viewProspectDetails(row)}

                                            gutterBottom
                                            style={{ cursor: "pointer" }}
                                          >
                                            {value}
                                          </Link>
                                        ) : column.id === "detailsButton" ? (
                                          <div>
                                            <Button
                                              variant="contained"
                                              color="primary"
                                              style={{
                                                borderRadius: 10,
                                                marginLeft: 10,
                                                textTransform: "math-auto",
                                              }}
                                              onClick={() => EditCountry(row)}
                                            >
                                              Edit
                                            </Button>
                                          </div>
                                        ) : column.id === "editButton" ? (
                                          <div>
                                            <Button
                                              variant="contained"
                                              color="primary"
                                              style={{
                                                borderRadius: 10,
                                                marginLeft: 10,
                                                textTransform: "math-auto",
                                              }}
                                              onClick={() => DeleteRole(row)}
                                            >
                                              Delete
                                            </Button>
                                          </div>
                                        ) : (
                                          value
                                        )}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>
                              );
                            })}
                        </>
                      ) : (
                        <TableCell
                          colspan="6"
                          style={{ "text-align": "center", margin: "10px 0px" }}
                        >
                          Records Not Available
                        </TableCell>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </Grid>
      <Dialog
        open={editProposal}
        onClose={handleClose}
        //   PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Do you really want to approve the Advise?
        </DialogTitle>
        <DialogContent>
          {/* Are you sure to Delete Role {currentUser.role}? */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            No
          </Button>
          <Button
            autoFocus
            onClick={sendToProposal}
            variant="contained"
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={deleteCountry}
        onClose={handleClose}
        //   PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Do you really want to delete?
        </DialogTitle>
        <DialogContent>
          {/* Are you sure to Delete Role {currentUser.role}? */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            No
          </Button>
          <Button
            autoFocus
            onClick={submitDelete}
            variant="contained"
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={editModal}
        onClose={handleClose}
        //   PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Editing
        </DialogTitle>
        <DialogContent>
          <TextField
            variant="outlined"
            value={isinNumbers.ISINCode}
            disabled
            label="ISINCode"
          />
          {/* Are you sure to Delete Role {currentUser.role}? */}
          <TextField
            variant="outlined"
            value={editAmount}
            label="Amount"
            onChange={(e) => editAmountValidations(e)}
            style={{
              marginLeft: "25px",
              width: "300px",
            }}
            // onChange={(e) => setEditAmount(e.target.value)}
          />
          {editCountryAmount ? (
            <p style={{ color: "blue" }}>Valid Amount</p>
          ) : (
            <p style={{ color: "red" }}>Please enters valid amount</p>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            Cancel
          </Button>
          <Button
            autoFocus
            onClick={(e) => editCountry(e)}
            variant="contained"
            color="primary"
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
      {showPDFeditfields ? (
        <Dialog
          open={showPDFeditfields}
          className="dialouge_adaadvice"
          fullWidth
          maxWidth="lg"
        >
          <DialogContent>
            <p
              style={{
                textAlign: "right",
                paddingRight: 10,
                cursor: "pointer",
              }}
            >
              <CancelOutlined onClick={() => setshowPDFeditfields(false)} />
            </p>
            <div>
              <div>
                <p style={{ display: "flex", alignItems: "center" }}>
                  {" "}
                  <b style={{ marginRight: 5, width: "170px" }}>
                    Client Name for PDF:
                  </b>
                  <TextField
                    variant="outlined"
                    onChange={(e) => setpdfName(e.target.value)}
                    value={pdfName}
                  />
                </p>
                <p style={{ display: "flex", alignItems: "center" }}>
                  {" "}
                  <b style={{ marginRight: 5, width: "200px" }}>
                    Add text above the table:
                  </b>
                  <div style={{ width: "100%" }}>
                    <Editor
                      defaultContentState={contentState}
                      // editorState={editorState}
                      onEditorStateChange={seteditorAbovetable}
                      wrapperClassName="wrapper-class"
                      editorClassName="editor-class"
                      toolbarClassName="toolbar-class"
                      // toolbarHidden={true}
                      toolbar={{
                        options: ["inline"],
                        inline: {
                          options: ["bold"],
                        },
                      }}
                    />
                  </div>
                </p>

                <p style={{ display: "flex", alignItems: "center" }}>
                  {" "}
                  <b style={{ marginRight: 5, width: "200px" }}>
                    Add text below the table:
                  </b>
                  <div style={{ width: "100%" }}>
                    <Editor
                      defaultContentState={contentState}
                      // editorState={editorState}
                      onEditorStateChange={seteditorBelowtable}
                      wrapperClassName="wrapper-class"
                      editorClassName="editor-class"
                      toolbarClassName="toolbar-class"
                      // toolbarHidden={true}
                      toolbar={{
                        options: ["inline"],
                        inline: {
                          options: ["bold"],
                        },
                      }}
                    />
                  </div>
                </p>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      ) : (
        ""
      )}

      {dialouge ? (
        <Dialog open={openComment}>
          <div
            style={{
              textAlign: "right",
              paddingRight: 20,
              paddingTop: 20,
              cursor: "pointer",
            }}
          >
            <CancelOutlined onClick={openCommentClose} />
          </div>
          <DialogTitle>
            <DialogContent>
              <label>
                Comments <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <textarea
                placeholder="comments"
                rows="7"
                cols="45"
                onChange={(e) => setComments(e.target.value)}
              ></textarea>
            </DialogContent>
            <DialogActions>
              <Button
                color="primary"
                variant="contained"
                onClick={submitDialog}
              >
                Submit
              </Button>
            </DialogActions>
          </DialogTitle>
        </Dialog>
      ) : null}
    </Grid>
  );
}

export default CreateAdviseRequest;
